<hum-icon [icon]="icon" class="icon"></hum-icon>
<div class="text">
    {{text}}
</div>